import React from 'react'

function Explore() {
  return (
    <div className=" ">
      Explore
    </div>
  );
}

export default Explore